import React from 'react';
import { ShoppingCartIcon, CheckCircleIcon } from 'lucide-react';
export function BabyCTASection() {
  return <section id="comprar" className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-blue-light via-baby-lavender to-baby-pink-light" data-id="element-44">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-45">
        <div className="bg-white/95 backdrop-blur-baby p-6 sm:p-8 md:p-10 lg:p-12 rounded-baby-lg shadow-baby-glow text-center border-2 border-baby-lavender animate-fade-in-up" data-id="element-46">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4 md:mb-6 bg-gradient-to-r from-baby-pink via-baby-lavender to-baby-blue bg-clip-text text-transparent" data-id="element-47">
            Mientras imaginas una semana sin improvisar...
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-4 sm:mb-6 md:mb-8 text-gray-700" data-id="element-48">
            Mientras sientes cómo sería tenerlo todo claro...
          </p>

          <div className="bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-5 sm:p-6 md:p-8 rounded-baby border-2 border-baby-lavender mb-6 sm:mb-8" data-id="element-49">
            <p className="text-lg sm:text-xl md:text-2xl font-bold mb-3 sm:mb-4 text-gray-900" data-id="element-50">
              Haz clic ahora.
            </p>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-2" data-id="element-51">
              Ve el método paso a paso.
            </p>
            <p className="text-sm sm:text-base md:text-lg text-gray-700" data-id="element-52">
              Organiza la comida de tu bebé desde hoy.
            </p>
          </div>

          <a href="https://mikioscodigital.com/cart/51716038885657:1" target="_blank" rel="noopener noreferrer" className="group relative inline-block w-full sm:w-auto mb-4 sm:mb-6" style={{
          perspective: '1000px'
        }} data-id="element-53">
            {/* 3D Button Container */}
            <div className="relative transition-all duration-500 ease-out group-hover:scale-105 group-hover:-translate-y-2" style={{
            transformStyle: 'preserve-3d',
            transform: 'rotateX(5deg)'
          }} data-id="element-54">
              {/* 3D Depth Layers */}
              <div className="absolute inset-0 bg-gradient-to-br from-amber-400 via-pink-500 to-purple-600 rounded-2xl shadow-2xl" style={{
              transform: 'translateZ(12px)'
            }} data-id="element-55"></div>
              <div className="absolute inset-0 bg-gradient-to-br from-amber-500 via-pink-600 to-purple-700 rounded-2xl" style={{
              transform: 'translateZ(10px)'
            }} data-id="element-56"></div>
              <div className="absolute inset-0 bg-gradient-to-br from-amber-600 via-pink-700 to-purple-800 rounded-2xl" style={{
              transform: 'translateZ(8px)'
            }} data-id="element-57"></div>
              <div className="absolute inset-0 bg-gradient-to-br from-amber-700 via-pink-800 to-purple-900 rounded-2xl" style={{
              transform: 'translateZ(6px)'
            }} data-id="element-58"></div>
              <div className="absolute inset-0 bg-gradient-to-br from-amber-800 via-pink-900 to-purple-950 rounded-2xl" style={{
              transform: 'translateZ(4px)'
            }} data-id="element-59"></div>

              {/* Main Button Surface */}
              <div className="relative px-8 py-5 sm:px-10 sm:py-6 md:px-12 md:py-7 rounded-2xl overflow-hidden" style={{
              transform: 'translateZ(14px)'
            }} data-id="element-60">
                {/* Animated gradient background */}
                <div className="absolute inset-0 bg-gradient-to-r from-amber-400 via-pink-500 to-purple-600 animate-gradient-x" data-id="element-61"></div>

                {/* Glossy shine overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-transparent to-transparent opacity-60" data-id="element-62"></div>

                {/* Shimmer effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-63"></div>

                {/* Button content */}
                <div className="relative flex items-center justify-center gap-3" data-id="element-64">
                  <ShoppingCartIcon className="w-6 h-6 sm:w-7 sm:h-7 text-white drop-shadow-lg animate-bounce" data-id="element-65" />
                  <span className="font-black text-xl sm:text-2xl md:text-3xl text-white uppercase tracking-wide drop-shadow-2xl" data-id="element-66">
                    ¡Quiero Mi Pack Ahora!
                  </span>
                </div>
              </div>

              {/* Outer glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-amber-300 via-pink-400 to-purple-500 rounded-2xl blur-2xl opacity-0 group-hover:opacity-80 transition-opacity duration-500" style={{
              transform: 'translateZ(-10px)'
            }} data-id="element-67"></div>

              {/* Pulsing glow ring */}
              <div className="absolute inset-0 bg-gradient-to-r from-amber-400 via-pink-500 to-purple-600 rounded-2xl blur-xl opacity-60 animate-pulse" style={{
              transform: 'translateZ(-5px)'
            }} data-id="element-68"></div>
            </div>
          </a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm md:text-base text-gray-700" data-id="element-69">
            <div className="flex items-center gap-2" data-id="element-70">
              <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-blue flex-shrink-0" data-id="element-71" />
              <span data-id="element-72">Descarga Instantánea</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-73">
              <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-pink flex-shrink-0" data-id="element-74" />
              <span data-id="element-75">Garantía 30 Días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-76">
              <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-lavender flex-shrink-0" data-id="element-77" />
              <span data-id="element-78">Pago Seguro</span>
            </div>
          </div>

          <p className="mt-4 sm:mt-6 text-sm sm:text-base md:text-lg italic text-gray-600" data-id="element-79">
            Tú pones el amor. Este ebook pone el plan.
          </p>
        </div>
      </div>
    </section>;
}